export default {
  common: { all: '全部', yes: '是', no: '否' },
  actions: {
    publishTask: '發佈任務', search: '查詢', reset: '重置', view: '查看', edit: '編輯', withdraw: '撤回', resend: '重發',
    confirmWithdraw: '確認撤回', cancel: '取消', back: '返回', saveSchedule: '儲存預約', saveDraft: '儲存草稿',
    schedulePublish: '預約發佈', publish: '發佈', backToEdit: '返回修改', confirmSchedule: '確認預約',
    confirmPublish: '確認發佈', close: '關閉', viewReceipt: '查看回執',
  },
  fields: {
    taskName: '任務名稱', formType: '表單類型', department: '學部', grade: '年級', receiverRole: '接收角色',
    status: '任務狀態', publishTime: '發佈時間', deadline: '截止時間', completion: '完成情況', scope: '接收範圍',
    operation: '操作', publishMode: '發佈方式', scheduledPublishTime: '預約發佈時間', publishDescription: '發佈說明',
  },
  placeholders: {
    taskName: '請輸入任務名稱', startTime: '開始時間', endTime: '結束時間', autoTaskName: '例如：2026 學生註冊資料收集',
    selectFormType: '請選擇表單類型', selectDepartment: '請選擇學部', selectGrade: '請選擇年級（可多選）', noGradeRequired: '該學部未設定年級，無需選擇',
    selectReceiverRole: '請選擇接收角色',
    selectScheduledTime: '請選擇預約發佈時間', selectDeadline: '請選擇截止時間',
    publishDescription: '例如：請在截止日期前核對資料並完成電子簽署', studentName: '請輸入學生姓名', studentNo: '請輸入學生編號',
  },
  department: { kindergarten: '幼稚園', primary: '小學', secondary: '中學' },
  formType: { registration: '學生註冊表', health: '健康申報表' },
  receiverRole: { parent: '家長', student: '學生', both: '家長、學生' },
  status: { draft: '草稿', scheduled: '預約發佈', published: '已發佈', ended: '已截止', withdrawn: '已撤回' },
  itemStatus: { pending: '待完成', completed: '已完成', incomplete: '未完成' },
  publishMode: { immediate: '立即發佈', scheduled: '預約發佈' },
  editor: {
    createTitle: '發佈資料表任務', editTitle: '編輯資料表任務', steps: '填寫任務資訊 · 預覽接收範圍 · 確認發佈',
    taskInfo: '任務資訊', gradeMultiple: '年級（可多選）', estimatedStudents: '預計命中學生：', studentUnit: '人', systemGeneratedName: '由系統自動產生任務名稱',
    publishNotice: '任務發佈後可撤回；截止時間以伺服器時間為準。同一學部和年級下，同一表單類型僅允許一個進行中的任務。',
    publishRuleTitle: '發佈校驗規則',
    publishRuleDescription: '同一學部、年級和表單類型只允許存在一個進行中的任務；如已有進行中任務，請先撤回或等待截止後再發佈。',
  },
  validation: {
    taskNameLength: '任務名稱最多 50 個字元', departmentRequired: '請選擇學部', gradeRequired: '請至少選擇一個年級',
    formTypeRequired: '請選擇表單類型', receiverRoleRequired: '請至少選擇一個接收角色',
    scheduledTimeRequired: '請選擇預約發佈時間', deadlineRequired: '請選擇截止時間', futureTime: '時間必須晚於目前時間',
    scheduleBeforeDeadline: '預約發佈時間必須早於截止時間', descriptionLength: '發佈說明最多 200 個字元',
  },
  messages: {
    cannotWithdraw: '目前任務已不可撤回，請重新整理列表後再試', withdrawTitle: '撤回任務？',
    withdrawDescription: '撤回後小程序不可再提交，已完成的提交回執會保留。', withdrawSuccess: '任務已撤回',
    resendTitle: '重新發佈任務？', resendDescription: '將以原任務內容建立並立即發佈一項新任務。', resendSuccess: '任務已重新發佈，共產生 {count} 條學生任務',
    draftSaved: '草稿已儲存', scheduleSaved: '預約設定已儲存', noStudents: '目前範圍沒有可發佈的學生',
    scheduleSuccess: '任務已預約發佈', publishSuccess: '任務發佈成功，共產生 {count} 條學生任務', loadDetailFailed: '任務詳情載入失敗',
  },
  confirm: {
    publishTitle: '確認發佈任務？', scheduleTitle: '確認預約發佈？',
    publishDescription: '發佈後將按目前範圍凍結學生名單和表單版本。',
    scheduleDescription: '到達預約時間後，服務端將按目前範圍自動發佈任務。',
  },
  states: { loading: '正在載入任務列表...', empty: '目前篩選條件下暫無任務' },
  stats: { target: '任務學生數量', completed: '已完成', pending: '待完成', incomplete: '未完成', withdrawnUnsubmitted: '撤回時未提交' },
  student: {
    studentName: '學生', studentNo: '學生編號', class: '年級/班級', seatNo: '班內號', submitter: '提交人',
    mobile: '提交手機號碼', completedTime: '提交時間',
  },
  submission: {
    title: '提交回執', submitter: '提交人', mobile: '提交手機號碼', submittedTime: '提交時間', confirmed: '電子確認',
    formVersion: '表單版本', formData: '提交內容', field: '欄位', value: '內容', noData: '暫無提交內容',
  },
}
